module.exports = __webpack_public_path__ + "media/services/smart-invest-icon-5dedadef.svg";